import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const CComPrimaryIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M12,2.05a10.48,10.48,0,0,0-10.4,9.4,1,1,0,0,0,.95,1.05h0a.93.93,0,0,0,.93-.83,8.55,8.55,0,0,1,17,0,.93.93,0,0,0,.93.83h0a1,1,0,0,0,.95-1.05A10.48,10.48,0,0,0,12,2.05Zm0,3.8a6.64,6.64,0,0,0-6.56,5.57,1,1,0,0,0,.94,1.08h0a1,1,0,0,0,.93-.81,4.75,4.75,0,0,1,9.36,0,1,1,0,0,0,.93.81h0a1,1,0,0,0,.94-1.08A6.64,6.64,0,0,0,12,5.85Zm0,4.27a2.38,2.38,0,0,0-.95,4.55v2.46H7.5a.67.67,0,0,0-.67.67h0v3.48a.66.66,0,0,0,.66.67h9a.67.67,0,0,0,.67-.67h0V17.8a.66.66,0,0,0-.66-.67H13V14.67A2.38,2.38,0,0,0,12,10.12ZM8.68,19h1.1v1.1H8.68Zm2.77,0h1.1v1.1h-1.1Zm2.76,0h1.1v1.1h-1.1Z" />
    </SvgIcon>
  )
}

export default CComPrimaryIcon
